import * as string from './string'

/**
 * Extends yup base schemas with new methods.
 * @see https://www.npmjs.com/package/yup
 */
export default {
  string
}
